import React from 'react';
import { Popover } from '@unite-us/app-components';
import PropTypes from 'prop-types';

export default function BaseToolTip({
  children,
  condition,
  position,
  text,
}) {
  return condition ? (
    <Popover
      content={text}
      position={position}
      trigger="hover"
      width="80"
    >
      {children}
    </Popover>
  ) : children;
}

BaseToolTip.propTypes = {
  children: PropTypes.node.isRequired,
  condition: PropTypes.bool,
  position: PropTypes.oneOf([
    'top',
    'top-start',
    'top-end',
    'right',
    'bottom',
    'bottom-start',
    'bottom-end',
    'left',
  ]),
  text: PropTypes.string.isRequired,
};

BaseToolTip.defaultProps = {
  condition: true,
  position: 'bottom-start',
};
